import React, { useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  Tabs,
  Tab,
  Divider,
  AppBar,
  Toolbar,
  IconButton,
  Button
} from '@mui/material';
import { ArrowBack, ArrowForward, Download } from "@mui/icons-material";
import AdminConfigurations from './AdminConfigurations';
import SecurityUsers from './SecurityUsers';

function AdminPanel() {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // No need for date formatting since we're not using it
  return (
    <Box sx={{
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      position: 'relative',
      maxHeight: '800px',
      borderRadius: '5px',
      bgcolor: 'background.paper',
      boxShadow: '0 0 10px rgba(0,0,0,0.1)',
    }}>
      {/* Header AppBar */}
      <AppBar position="static" color="default" sx={{
        bgcolor: 'background.paper',
        borderTopLeftRadius: '5px',
        borderTopRightRadius: '5px',
        boxShadow: 1,
      }}>
        <Toolbar sx={{ minHeight: '80px !important', gap: 2 }}>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            <Box sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 1,
            }}>
              <Box sx={{
                backgroundColor: '#3d8ad7',
                color: 'white',
                padding: '8px 16px',
                borderRadius: '4px',
                fontWeight: 'medium',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              }}>
                Administration
              </Box>
            </Box>
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Tabs */}
      <Paper sx={{ boxShadow: 'none' }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="fullWidth"
          sx={{
            '& .MuiTabs-indicator': {
              backgroundColor: '#1976d2',
              height: '3px',
            },
            '& .MuiTab-root': {
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '1rem',
              minHeight: '56px',
              '&.Mui-selected': {
                color: '#1976d2',
              },
            },
          }}
        >
          <Tab label="Configurations" />
          <Tab label="Security & Users" />
        </Tabs>
        <Divider />
      </Paper>

      {/* Scrollable Content Area */}
      <Box sx={{
        flex: 1,
        overflow: 'hidden',
        maxHeight: 'calc(100vh - 200px)'
      }}>
        <Box sx={{
          height: '100%',
          overflow: 'auto',
          '&::-webkit-scrollbar': { width: '8px' },
          '&::-webkit-scrollbar-thumb': { bgcolor: 'grey.400' },
          boxShadow: 'none',
          p: 3,
          minHeight: '70vh'
        }}>
          {activeTab === 0 && <AdminConfigurations />}
          {activeTab === 1 && <SecurityUsers />}
        </Box>
      </Box>
    </Box>
  );
}

export default AdminPanel;